import request, { ResponsePageableData } from '@/libs/request'

//获取配置项信息
export const getConfigValue = (data?) => request<ResponsePageableData>({ url: '/adminapi/Config/getConfigValue', data })

//获取配置项信息
export const setConfigValue = (data?) => request<ResponsePageableData>({ url: '/adminapi/Config/setConfigValue', data })

export const getVipLevel = (data?) => request<ResponsePageableData>({ url: '/adminapi/Config/vipLevel', data })
